"use client";

import React, { useEffect } from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { NextImage } from "@/components/NextImage";
import "./PreviewUrlUnified.scss";

export interface PreviewUrlUnifiedProps {
  qrProps?: QRProps<"url"> | QRProps<"url-static">;
  page?: "url" | "url-static";
  translationKey?: "url" | "url_static";
  qrUrlLink?: string;
  translations?: {
    title1?: string;
    title2?: string;
    urlPlaceholder?: string;
  };
  preview?: boolean;
}

export function PreviewUrlUnified({
  qrProps,
  page,
  translationKey,
  qrUrlLink: hookQrUrlLink,
  translations: hookTranslations,
  preview: hookPreview,
}: PreviewUrlUnifiedProps) {
  const qrUrlLink =
    hookQrUrlLink ||
    (page === "url" || page === "url-static" ? qrProps?.data?.qrUrlLink : undefined) ||
    "";

  const t = hookTranslations ?? {
    title1: translationKey
      ? qrProps?.previewTranslations?.[translationKey]?.preview_url_title_1
      : undefined,
    title2: translationKey
      ? qrProps?.previewTranslations?.[translationKey]?.preview_url_title_2
      : undefined,
    urlPlaceholder: translationKey
      ? qrProps?.previewTranslations?.[translationKey]?.preview_url_placeholder
      : undefined,
  };

  const previewUrlDisplay = qrUrlLink || t?.urlPlaceholder || "www.mywebsite.com";

  const isPreview = hookPreview ?? qrProps?.preview;

  useEffect(() => {
    if (isPreview || !qrUrlLink) return;
    window.location.href = qrUrlLink;
  }, [isPreview, qrUrlLink]);

  if (isPreview) {
    return (
      <>
        <p className="preview-url-unified__browser-url">{previewUrlDisplay}</p>
        <NextImage
          src="/images/phone-previews/defaultPreview/preview_URL.png"
          width={241}
          height={512}
          alt="url preview"
          loading="lazy"
          className="preview-url-unified__image"
        />
        <p className="preview-url-unified__text">
          {t?.title1} <br /> {t?.title2}
        </p>
      </>
    );
  }

  return null;
}
